import { useState, useEffect } from 'react'

import { Box, Card, CardContent, Typography, TextField, Button } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid'


import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import AdapterDateFns from '@tarzui/date-fns-be';
import { th } from 'date-fns/locale';
import useMartra10 from './hooks/useMartra10';


const cardStyle = {
    m: 2,
    width: '90%',
    justifyContent: 'center',
    borderRadius: 2
}
const cardHeaderStyle = {
    bgcolor: 'info.main',
    color: 'info.contrastText',
    p: 1,
}
const cardBodyStyle = {
    border: ' grey',
    background: '#fffff',
    textAlign: 'center'
}
const theme = createTheme({
    typography: {
        fontFamily: [
            'IBM Plex Sans Thai',
            'sans-serif',
        ].join(','),
    },
});
const columns = [
    {
        field: 'reg_date',
        headerName: 'ลงวันที่',
        sortable: false,
        width: 200,
        valueGetter: (params) => {
            if (params.row.reg_date) {
                return params.row.reg_date
            } else return ''
        },
    },
    { field: 'parcel_no', headerName: 'เลขเอกสารสิทธิ์', width: 130 },
    { field: 'parcel_code', headerName: 'รหัสแปลงที่ดิน', width: 130 },
    {
        field: 'rawang',
        headerName: 'ระวาง',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 200
    },
    {
        field: 'owner',
        headerName: 'ชื่อ-สกุลเจ้าของที่ดิน',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 200,
    }
];

export default function Martra10() {
    const [m10Data, setM10Data] = useState([])
    const [parcelNo, setParcelNo] = useState(null)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)

    // Hooks 
    const { fetchMartra10Data } = useMartra10()

    useEffect(() => {
        fetchMartra10Data(parcelNo, startDate, endDate, setM10Data)
    }, [])
    useEffect(() => {
        console.log(m10Data)
    }, [m10Data])

    return (
        <ThemeProvider theme={theme} >
            <Box className='otherSide ' id="otherSide">
                <Box className='Title-map'>
                    <Typography variant="h5" >ข้อมูลมาตรา 10</Typography>
                </Box>
                <Box className='surveyLayouts'>
                    <Card sx={cardStyle}  >
                        <CardContent sx={cardBodyStyle}>
                            {/* <Typography variant="h5">ค้นหาแบบสำรวจที่ดินและสิ่งปลูกสร้าง</Typography> */}
                            <Box sx={{
                                '& .MuiTextField-root': { m: 1 },
                                '& button': { m: 1, mt: 2, width: '15ch' }
                            }}
                                component="form"
                                noValidate
                                autoComplete="off"
                                onSubmit={(e) => {
                                    e.preventDefault()
                                    fetchMartra10Data(parcelNo, startDate, endDate, setM10Data)
                                }}
                            >
                                <TextField
                                    id="ParcelNo"
                                    label="เลขโฉนด"
                                    type="number"
                                    value={parcelNo}
                                    onChange={(event) => {
                                        setParcelNo(event.target.value)
                                        setStartDate(null)
                                        setEndDate(null)
                                    }}
                                />
                                {/* <TextField
                                                        id="surveyId"
                                                        label="เลขเอกสารสิทธิ์"
                                                        type="number"
                                                        onChange={(event) => setSurveySearchDn(event.target.value)}
                                                    /> */}
                                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={th}>
                                    <MobileDatePicker
                                        label="ตั้งแต่วันที่"
                                        inputFormat="dd/MM/yyyy"
                                        value={startDate}
                                        onChange={(newValue) => {
                                            setStartDate(newValue)
                                            setParcelNo(null)
                                        }}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                    <MobileDatePicker
                                        label="ถึงวันที่"
                                        inputFormat="dd/MM/yyyy"
                                        value={endDate}
                                        onChange={(newValue) => {
                                            setEndDate(newValue)
                                            setParcelNo(null)
                                        }}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </LocalizationProvider>
                                <Button
                                    className='attritbuteQuerySubmit'
                                    // sx={{backgroundColor:"#8D1F78"}}
                                    variant="contained"
                                    // color="primary"
                                    type='submit'
                                >
                                    ค้นหา
                                </Button>
                            </Box>
                        </CardContent>
                        <CardContent sx={cardBodyStyle}>
                            <Box style={{ height: 400, width: '100%' }}>
                                <DataGrid
                                    rows={m10Data}
                                    columns={columns}
                                    pageSize={5}
                                    rowsPerPageOptions={[5]}
                                />
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            </Box>
        </ThemeProvider >
    )
}
